import store from '@/store';
import {
  CLEAR_ACCOUNT_ISLOADING,
  CLEAR_ANNOUNCEMENT_ISLOADING,
  CLEAR_SHIUREI_TORAH_ISLOADING,
  CLEAR_SHIUREI_TORAH_TEMPLATE_ISLOADING,
  CLEAR_DONATION_ISLOADING,
  CLEAR_KABBALAH_DESIGN_N_ISLOADING,
  CLEAR_KABBALAH_N_ISLOADING,
  CLEAR_MINYANIM_ISLOADING,
  CLEAR_ORGANIZATION_ISLOADING,
  CLEAR_SCREEN_ISLOADING,
  CLEAR_TEMPLATE_ISLOADING,
  CLEAR_ZMANIM_ISLOADING,
} from '@/store/action_types';

export const resetLoaders = () => {
  store.dispatch(CLEAR_ACCOUNT_ISLOADING);
  store.dispatch(CLEAR_ANNOUNCEMENT_ISLOADING);
  store.dispatch(CLEAR_SHIUREI_TORAH_ISLOADING);
  store.dispatch(CLEAR_SHIUREI_TORAH_TEMPLATE_ISLOADING);
  store.dispatch(CLEAR_DONATION_ISLOADING);
  store.dispatch(CLEAR_KABBALAH_N_ISLOADING);
  store.dispatch(CLEAR_KABBALAH_DESIGN_N_ISLOADING);
  store.dispatch(CLEAR_MINYANIM_ISLOADING);
  store.dispatch(CLEAR_ORGANIZATION_ISLOADING);
  store.dispatch(CLEAR_SCREEN_ISLOADING);
  store.dispatch(CLEAR_TEMPLATE_ISLOADING);
  store.dispatch(CLEAR_ZMANIM_ISLOADING);
};
